<template>
    <div id="app">
        <div class="head" style="border-bottom: 2px solid #eee;">
            <div style="width:1400px;margin: 0 auto;padding: 15px 0;">
                <div class="left logo" style="padding-top: 10px;">
                    <a @click="changeRoute('/')" style="color: #687074;text-decoration: none;"><img
                      src="@/assets/img/logo.png" height="70px;"></a>
                </div>
                <div class="right" style="width: 68%;text-align: right;">
                    <div class="search">
                        <div>
                            <input v-model="key" type="text" placeholder="Search by Address / Txhash / Block " name="q"
                                   maxlength="80"
                                   style="width: 330px; height: 31px; box-sizing: border-box" autocomplete="off">
                            <span class="" style="display: inline">
                                <button class="btn-u" @click="search()"
                                    style="padding: 3px 6px 3px 6px; height: 32px; width: 41px; margin-left: -5px; margin-top: 3px;">GO</button>
                            </span>
                        </div>
                    </div>
                    <div class="menu" style="margin-top: 10px;width: 100%; text-align: left; font-size: 16px;">
                        <a @click="changeRoute('/')" style="cursor: pointer"> HOME </a>
                        <a @click="changeRoute('/blockList')" style="cursor: pointer"> BLOCKS </a>
                        <a @click="changeRoute('/transactionList')" style="cursor: pointer"> TRANSACTIONS </a>
<!--                        <a @click="changeRoute('/ETSL')" style="cursor: pointer"> ETSL </a>-->
<!--                        <a @click="changeRoute('/MPL')" style="cursor: pointer"> MPL </a>-->
                        <a @click="changeRoute('/ETHC')" style="cursor: pointer"> ETHC </a>
                        <a @click="changeRoute('/EUSD')" style="cursor: pointer"> EUSD </a>
<!--                      <a @click="changeRoute('/PPS2')" style="cursor: pointer"> PPS </a>-->
<!--                      <a @click="changeRoute('/CMC')" style="cursor: pointer"> CMC </a>-->
<!--                      <a @click="changeRoute('/FCT')" style="cursor: pointer"> FCT </a>-->
<!--                      <a @click="changeRoute('/NBC')" style="cursor: pointer"> NBC </a>-->
<!--                      <a @click="changeRoute('/NBA')" style="cursor: pointer"> NBA </a>-->
                      <a @click="changeRoute('/NBC3')" style="cursor: pointer"> NBC³ </a>
                      <a @click="changeRoute('/FGC')" style="cursor: pointer"> FGC </a>
                      <a @click="changeRoute('/NBC33')" style="cursor: pointer"> NBC³⁺ </a>
                      <a @click="changeRoute('/FGC3')" style="cursor: pointer"> FGC⁺ </a>
<!--                      <a @click="changeRoute('/pps')" style="cursor: pointer"> pps </a>-->
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <router-view/>
        <div class="foot" style="border-top: 2px solid #eee; margin-top: 15px;">
            <div style="width:1200px;margin: 0 auto;padding: 15px 0;">
                <p>
                    ETSC © 2020 &nbsp;&nbsp;| &nbsp;&nbsp;Powered by ETSC Team
                </p>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>
<script>
import {getAddress} from '@/assets/js/etherjs/until';

export default {
    name: 'app',
    data() {
        return {
            key: "",
        }
    },
    mounted() {

    },
    methods: {
        search() {
            if (this.key.length == 42) {
                if (this.$route.name == "transactionList" || "ETSL") {
                    this.$router.push({
                        query: {'addr': getAddress(this.key)}
                    });
                } else {
                    this.changeRoute("/transactionList", {addr: getAddress(this.key)});
                }
            } else if (this.key.length == 66) {
                this.changeRoute("/transactionDetail", {hash: this.key});
            } else {
                if (!isNaN(this.key)) {
                    this.changeRoute("/blockDetail", {number: this.key});
                }
            }
        },
    }

}
</script>

<style lang="scss">
@import "assets/css/page.css";

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    /*color: #2c3e50;*/
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

body {
    color: #555;
    font-size: 13px;
    line-height: 1.6;
    padding: 0px;
    margin: 0px;
}

.menu a {
    color: #687074;
    text-decoration: none;
    margin-right: 25px;
}

.menu a:hover {
    color: #3498db;
    text-decoration: none;
}

.left {
    float: left;
}

.right {
    float: right;
}

.clear {
    clear: both;
    width: 0px;
    height: 0px;
}

.head {
    margin-top: 0px;
    margin-bottom: 10px;
}

.main {
    min-height: 500px;
}

.main {
    width: 1200px;
    margin: 0 auto;
    background-color: #f7f7f7;
    padding: 10px;
}

.left {
    float: left;
}

.right {
    float: right;
}

.clear {
    clear: both;
    width: 0px;
    height: 0px;
}

.width50 {
    width: 49%
}

.bgw {
    background-color: #ffffff;
}

.listcontent {
    width: 100%;
}

.blocklist {
}

.tranlist {
}

.btop {
    padding: 7px 15px;
    border-bottom: solid 3px #f7f7f7;
}

.btitle {
    font-size: 16px;
    line-height: 24px;
    height: 24px;
    font-weight: 400;
    margin: 0px;
}

.allbtn {
    font-size: 12px;
    line-height: 18px;
    cursor: pointer;
    text-decoration: none;
    border: 1px solid transparent;
    border-color: #555;
    padding: 5px 13px;
    color: #555;
}

.allbtn:hover {
    font-size: 12px;
    line-height: 18px;
    cursor: pointer;
    text-decoration: none;
    background-color: #555;
    border: 1px solid transparent;
    border-color: #555;
    padding: 5px 13px;
    color: #fff;
}

.binfo {
    padding: 10px 15px;
    margin-top: 2px;
}

.blockinfo {
    margin: 0px;
    line-height: 23px;
    height: 23px;
}

.blockinfo a {
    color: #3498db;
    text-decoration: none;
}

.blockinfo a:hover {
    color: #3498db;
    text-decoration: underline;
}

.linkblock:hover font {
    text-decoration: underline;
    text-decoration-color: #3498db;
}
</style>
